<script>
  import { _ } from 'svelte-i18n';
  import { createEventDispatcher } from 'svelte';

  import Modal from './Modal.svelte';

  export let options = [];
  export let noSelectedText;

  let showFilter = false;
  let selectedOptionName = '';

  const dispatch = createEventDispatcher();

  const onChangeFilter = (option) => {
    showFilter = false;

    if (option) {
      selectedOptionName = option.name;
      dispatch('change', { option });
    } else {
      selectedOptionName = '';  
      dispatch('change', { option: { value: '' } });
    }
  }
</script>

<div class="filter" tabindex="0" on:blur={() => showFilter = false}>
  <div class='filter__select' on:click={() => showFilter = !showFilter}>
    {#if selectedOptionName === ''}
      <div class="name">{noSelectedText}</div>
    {:else}
      <div class="name">{selectedOptionName}</div>
    {/if}

    {#if showFilter}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.76304 9.07614C3.04679 8.71302 3.44633 8.21781 3.90799 7.69212C4.36731 7.16909 4.90234 6.59959 5.45693 6.09559C5.9852 5.61551 6.60575 5.12551 7.24871 4.81855C7.28476 4.80065 7.32178 4.78413 7.35971 4.7691C7.61665 4.6657 7.85962 4.64644 8.01969 4.6478C8.17976 4.64644 8.42273 4.6657 8.67968 4.7691C8.7176 4.78413 8.75462 4.80065 8.79067 4.81855C9.43363 5.12551 10.0542 5.61551 10.5824 6.09559C11.137 6.59959 11.6721 7.16909 12.1314 7.69212C12.5931 8.21781 12.9926 8.71302 13.2763 9.07614C13.4761 9.33181 13.7082 9.58755 13.8574 9.87645C14.1827 10.506 14.0094 11.2963 13.4187 11.7259C12.7742 12.1946 11.8486 12.0461 11.3796 11.4034C10.5571 10.2846 9.64888 9.19141 8.61932 8.25577C8.39862 8.0552 8.1976 7.88952 8.01969 7.758C7.84178 7.88952 7.64076 8.0552 7.42006 8.25577C6.31112 9.26355 5.11077 10.8015 4.76118 11.267C4.255 11.941 3.36389 12.2664 2.62069 11.7259C1.98715 11.2651 1.8332 10.39 2.26023 9.74275C2.42172 9.51604 2.59169 9.29543 2.76304 9.07614Z" fill="#2B50ED"/>
      </svg>
    {:else}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.76304 7.57132C3.04679 7.93444 3.44633 8.42965 3.90799 8.95535C4.36731 9.47837 4.90234 10.0479 5.45693 10.5519C5.9852 11.032 6.60575 11.5219 7.24871 11.8289C7.28476 11.8468 7.32178 11.8633 7.35971 11.8784C7.61665 11.9818 7.85962 12.001 8.01969 11.9997C8.17976 12.001 8.42273 11.9818 8.67968 11.8784C8.7176 11.8633 8.75462 11.8468 8.79067 11.8289C9.43363 11.522 10.0542 11.032 10.5824 10.5519C11.137 10.0479 11.6721 9.47837 12.1314 8.95535C12.5931 8.42965 12.9926 7.93444 13.2763 7.57132C13.4761 7.31565 13.7082 7.05991 13.8574 6.77101C14.1827 6.14144 14.0094 5.35116 13.4187 4.92159C12.7742 4.45285 11.8486 4.60134 11.3796 5.24402C10.5571 6.36283 9.64888 7.45605 8.61932 8.39169C8.39862 8.59226 8.1976 8.75794 8.01969 8.88946C7.84178 8.75794 7.64076 8.59226 7.42006 8.39169C6.31112 7.38391 5.11077 5.84594 4.76118 5.38044C4.255 4.70644 3.36389 4.38107 2.62069 4.92159C1.98715 5.38234 1.8332 6.25745 2.26023 6.90472C2.42172 7.13142 2.59169 7.35204 2.76304 7.57132Z" fill="#2B50ED"/>
      </svg>        
    {/if}
  </div>

  <Modal 
    show={showFilter}
    top="45px"
    width="100%"
    height="300px"
  >
    <div 
      class="filter-option" 
      on:click={() => onChangeFilter()}
    >
      -----
    </div>
    
    {#each options as option}
      <div 
        class="filter-option" 
        style:color={option.name === selectedOptionName ? '#576CED' : ''}
        on:click={() => onChangeFilter(option)}
      >
        {option.name}
      </div>
    {/each}   
  </Modal>
</div>

<style lang="scss">
  .name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    &:first-letter {
      text-transform: uppercase;
    } 
  }

  .filter {
    border-radius: 8px;
    padding: 8px 10px;
    background: #E0E8F6;
    width: 200px;
    margin-bottom: 30px;
    position: relative;
    box-sizing: border-box;

    @media (max-width: 768px){
      border-radius: 4px;
      padding: 12px;
      width: auto;
    }

    @media (max-width: 576px) {
      margin-bottom: 8px;
    }
  }

  .filter__select {
    grid-gap: 10px;
    display: grid;
    grid-template-columns: 1fr 16px;
    align-items: center;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #2B50ED;
  }

  .filter-option {
    color: #22252C;
    cursor: pointer;
    padding-left: 16px;
    padding-bottom: 10px;

    &:first-letter {
      text-transform: uppercase;
    } 

    &:first-child {
      padding-top: 16px;
    }

    &:last-child {
      padding-bottom: 16px;
    }
  }
</style>
